import { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { C } from '../styles/tokens.js';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export default function PdfThumbnail({ url, blob, width = 200, height = 260, page = 1 }) {
  const canvasRef = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!canvasRef.current || (!url && !blob)) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const src = blob ? { data: await blob.arrayBuffer() } : { url };
        const pdf = await pdfjsLib.getDocument(src).promise;
        if (cancelled) return;
        const p = await pdf.getPage(page);
        const v0 = p.getViewport({ scale: 1 });
        const scale = Math.min(width / v0.width, height / v0.height);
        const viewport = p.getViewport({ scale });
        const canvas = canvasRef.current;
        if (!canvas) return;
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');
        await p.render({ canvasContext: ctx, viewport }).promise;
        if (!cancelled) setLoading(false);
      } catch (e) {
        if (!cancelled) { setError(e.message || 'PDF 로드 실패'); setLoading(false); }
      }
    })();

    return () => { cancelled = true; };
  }, [url, blob, page, width, height]);

  return (
    <div style={{ width, height, background: '#fff', borderRadius: 4, position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `1px solid ${C.border}` }}>
      {loading && <div style={{ fontSize: 11, color: '#666' }}>PDF 로딩...</div>}
      {error && (
        <div style={{ fontSize: 10, color: '#999', padding: 10, textAlign: 'center' }}>
          ⚠ PDF 미리보기 불가<br />(URL 미지정 또는 CORS)
        </div>
      )}
      <canvas ref={canvasRef} style={{ display: error ? 'none' : 'block', maxWidth: '100%', maxHeight: '100%' }} />
    </div>
  );
}
